<div class="innerpage-fullwithbanner dashboardarea clearfix">
  <div class="left">
    <h2 class="bighead">{{property.IsPortfolio ? "Portfolio Details" : "Property Details"}}</h2>
    <ul class="bread-crumbs">
      <li *ngIf="this.authService.Principal() || this.authService.Seller() || this.authService.Principal1031()">
        <a (click)="onHomeBreadCrumbClick();">
          Home
          <span>|</span>
        </a>
      </li>
      <li *ngIf="!this.authService.Principal() && !this.authService.Seller() && !this.authService.Principal1031()"><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
      <li>
        <a (click)="onBreadCrumbClick();">{{prevPage}}<span>|</span></a>
      </li>
      <li>{{property.IsPortfolio ? "Portfolio Details" : "Property Details"}}</li>
    </ul>
  </div>
  <div class="right">

  </div>

</div>
<div class="clearfix"></div>
<div class="detailspage-banner propertyDetails-banner" id="divPropertyViewParent">
  <!--*ngIf="activeBannerTab == 1"-->
  <div class="fav-star">

  </div>

  <div class="propertyname">
    <h3>
      {{property.Tenant}}
      <a tooltip="{{toolTipFav}}" placement="top" *ngIf="showAddToFav" href="javascript:void(0);" [class]="classToBind" (click)="addToFav(property.Id);">
        <i class="fa fa-heart-o icon"></i>
      </a>
      <span *ngIf="haveaccesstoviewlocation">{{property.City ? property.City + ", " : ""}}{{property.State}}</span>
      <span *ngIf="!haveaccesstoviewlocation">Confidential</span>
    </h3>
  </div>
  <tabset #staticTabs>
    <a href="javascript:void(0);" class="open-video" *ngIf="property.VideoURL != null && property.VideoURL != ''" (click)="onVideoTabClick(video, 'property-video-preview modal-lg')">Video</a>
    <tab heading="Gallery" id="tab1" (select)="onBannerTabClick(1)">
      <!--<carousel *ngIf="property.Images != null && property.Images.length > 0">
          <slide *ngFor="let item of property.Images; let i=index">
              <img [src]="item.FilePath" class="img-responsive" (click)="open(i)">
          </slide>
      </carousel>-->
      <!--newslider stats-->

      <ngx-slick-carousel class="carousel" *ngIf="Images != null && Images.length > 0" #slickModal="slick-carousel" [config]="slideConfig"
                          (afterChange)="afterChange($event)">
        <div ngxSlickItem *ngFor="let slide of Images; let i=index" class="slide">
          <img (click)="open(i)" src="{{ slide.FilePath }}" attr.description="{{ slide.Description }}" attr.alt="{{slide.AlText}}" attr.Caption="{{slide.Caption}}">
        </div>
      </ngx-slick-carousel>

      <!--new slider ends-->
      <div *ngIf="Images == null || Images.length == 0" class="heightfull">
        <img src="assets/img/defaultbanner-min.png" class="img-responsiveblock" />
      </div>
    </tab>
    <tab heading="Map" *ngIf="showmap" (selectTab)="onBannerTabClick(2)">
      <div class="mapdiv">
        <div #gmap class="mapheight"></div>
      </div>
    </tab>
    <tab heading="Satellite" *ngIf="showmap" (selectTab)="onBannerTabClick(3)">
      <div class="mapdiv">
        <div #gmapSatellite class="mapheight"></div>
      </div>
    </tab>
  </tabset>
  <div class="mobile_action_floated d-flex  justify-content-between" *ngIf="activeTab!=6">
    <div class="propertyname hidden-xs">
      <h3>
        {{property.Tenant}}
        <a tooltip="{{toolTipFav}}" placement="top" *ngIf="showAddToFav" href="javascript:void(0);" [class]="classToBind" (click)="addToFav(property.Id);">
          <i class="fa fa-heart-o icon"></i>
        </a>
        <span *ngIf="haveaccesstoviewlocation">{{property.City ? property.City + ", " : ""}}{{property.State}}</span>
        <span *ngIf="!haveaccesstoviewlocation">Confidential</span>
      </h3>
    </div>
    <div class="btn-right d-flex">
      <button (click)="onTabClickOM(propertyTabs.Memorandom);" *ngIf="property.PropertyStatus != 'BOV' && property.PropertyStatus != 'Pre-Marketing'" class="btn-lg btn-border btn adduserbtn">Download OM</button>
      <button (click)="openPlaceOfferTab(propertyTabs.PlaceOffer)" *ngIf="(property.PropertyStatus === 'Available' || property.PropertyStatus === 'Off-Market') && ((property.OfferPlaced == 0 || property.CancelledOffers !=0 || placeOfferVisibility) || authService.ExternalBroker()) && showPlaceOffer && !property.Archive" class="btn btn-success margin-left-10 btn-lg">Place Offer</button>
    </div>
  </div>

</div>

<div class="container propertyDetails-container" #hometop>
  <div class="section-margin">
    <div class="property-details clearfix" id="scrollingId-for-wizard">
      <div *ngIf="(isUserLoggedIn && canEditProperty && canEditPropertyForBroker &&  (authService.Admin()|| authService.SuperAdmin() || (authService.DataEntryStaff() && isPropertyForSale == false))) || (authService.Broker() && isPropertyForSale == false)">
        <div class="floated-btn" *ngIf="(isUserLoggedIn && canEditProperty && canEditPropertyForBroker) &&  (authService.Admin() || authService.SuperAdmin()|| authService.DataEntryStaff()) || (authService.Broker() && isPropertyForSale == false)">
          <button [disabled]="property.IsDeleted" *ngIf="isUserLoggedIn && canEditProperty && propertyGuid!=null && propertyGuid!='' && canEditPropertyForBroker" class="btn  btn-circle btn-green" ng-reflect-placement="top" ng-reflect-tooltip="Edit"
                  placement="top" tooltip="Edit" (click)="onEditPropertyClick();">
            <i aria-hidden="true" class="icofont icofont-ui-edit icon"></i>
          </button>
          <button [disabled]="property.IsDeleted" *ngIf="isUserLoggedIn && isPropertyForSale == false &&  (authService.Admin() || authService.SuperAdmin() || authService.DataEntryStaff() || authService.Broker())" class="btn  btn-circle btn-verify" ng-reflect-placement="top" ng-reflect-tooltip="Edit"
                  placement="left" tooltip="{{property.IsPortfolio ? 'Verify Portfolio':'Verify Property'}}" (click)="VerifyProperty(property.Id)">
            <i aria-hidden="true" class="icofont icofont-ui-check"></i>
          </button>
        </div>
      </div>
      <div class="property-details visible-xs margin-bottom-15">
        <div class="rightside clearfix padding0">
          <div class="halfwidth1100 ">
            <div class="border-div margin-bottom-10 pb-0">
              <div class="askingprice mb-0">
                <span class="two_sep">
                  <h3>
                    <span>Asking Price</span> {{(property.IsShowPrice) ? '$ '+(property.Price | number:0) : '--'}}
                  </h3>
                </span>
                <span class="right_cont two_sep">
                  <h3 class="pricedetails">
                    <span>Cap Rate</span>
                    <span *ngIf="capratetext == 'ZCF'">{{capratetext}}</span>
                    <span *ngIf="capratetext != 'ZCF'">{{ (property.CapRate && property.IsShowPrice) ? (property.CapRate | number : '1.2-2') + ' %' : '-' }}</span>
                  </h3>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="tabheadingsoverflow">
        <ul class="tabheadings clearfix d-flex">
          <li [class.active]="activeTab == propertyTabs.Dashboard" *ngIf="(authService.Admin()|| authService.SuperAdmin() || property.IsPropertyDashboardEnabled ||
                        ((property.PropertyStatus == 'BOV' || property.PropertyStatus == 'Pre-Marketing') && (authService.Seller() || authService.Broker())))">
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Dashboard);" *ngIf="!property.IsPortfolio">
              <span class="icon-tc icon"></span>Property Dashboard
            </a>
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Dashboard);" *ngIf="property?.IsPortfolio">
              <span class="icon-tc icon"></span>Portfolio Dashboard
            </a>
          </li>
          <li [class.active]="activeTab == propertyTabs.FinancialSummary" *ngIf="(authService.Admin() || authService.SuperAdmin() || authService.Broker()|| property.IsPropertyDashboardEnabled) && property.TickerSymbol">
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.FinancialSummary);">
              <span class="icon-finance icon"></span>Financial Summary
            </a>
          </li>
          <li [class.active]="activeTab == propertyTabs.Home">
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Home);">
              <span class="icon-propertydetails icon"></span>Details
            </a>
          </li>
          <li [class.active]="activeTab == propertyTabs.Memorandom" *ngIf="property.PropertyStatus != 'BOV' && property.PropertyStatus != 'Pre-Marketing'">
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Memorandom);">
              <span class="icon-download icon"></span>Offering Memorandum
            </a>
          </li>
          <li [class.active]="activeTab == propertyTabs.Diligence" *ngIf="property.PropertyStatus != 'BOV' && property.PropertyStatus != 'Pre-Marketing'">
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Diligence);">
              <span class="icon-folder icon"></span>Due Diligence
            </a>
          </li>
          <li [class.active]="activeTab == propertyTabs.Offer" *ngIf="property.PropertyStatus != 'BOV'
                        && property.PropertyStatus != 'Pre-Marketing' && canEditProperty && (!authService.DataEntryStaff()) && (!authService.Admin()&&!authService.SuperAdmin() && !property.IsPropertyDashboardEnabled)">
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Offer);">
              <span class="icon-offer icon"></span>Offers Placed
            </a>
          </li>
          <li [class.active]="activeTab == propertyTabs.Inquiries" *ngIf="property.PropertyStatus != 'BOV' && property.PropertyStatus != 'Pre-Marketing' && canEditProperty
                        && (!authService.DataEntryStaff()) && property.PropertyForId === 601 && (!authService.Admin() && !authService.SuperAdmin() && !property.IsPropertyDashboardEnabled)">
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Inquiries);">
              <span class="icon-note icon"></span>Placed Inquiries
            </a>
          </li>
          <li [class.active]="activeTab == propertyTabs.Comps" *ngIf="(authService.Admin() || authService.SuperAdmin() || authService.Broker() || authService.DataEntryStaff())">
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Comps);" *ngIf="!property.IsPortfolio">
              <span class="icon-comps icon"></span>Property History
            </a>
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Comps);" *ngIf="property?.IsPortfolio">
              <span class="icon-comps icon"></span>Portfolio History
            </a>
          </li>
          <!--<li [class.active]="activeTab == propertyTabs.Analytics" *ngIf="property.PropertyStatus === 'Available' && ((this.user.RoleId == this.authService.UserRole.Admin) || (this.user.RoleId == this.authService.UserRole.Broker) || (this.user.RoleId == this.authService.UserRole.DataEntryStaff))">
              <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Analytics);">
                  <span class="icon-analytics icon"></span>Analytics
              </a>
          </li>-->
          <!--<li [class.active]="activeTab == propertyTabs.PlaceOffer" *ngIf="(property.PropertyStatus === 'Available' || property.PropertyStatus === 'Off-Market') && ((property.OfferPlaced == 0 || property.CancelledOffers !=0 || placeOfferVisibility) || authService.ExternalBroker()) && showPlaceOffer">
            <a href="javascript:void(0);" (click)="openPlaceOfferTab(propertyTabs.PlaceOffer)">
              <span class="icon-placeoffer icon"></span>Place Offer
            </a>
          </li>-->
          <li [class.active]="activeTab == propertyTabs.OfferDetail" *ngIf="!canEditProperty && property.OfferPlaced==1 && !placeOfferVisibility">
            <a href="javascript:void(0);" (click)="openPlaceOfferTab(propertyTabs.OfferDetail);">
              <span class="icon-offer icon"></span>Offer Details
            </a>
          </li>
          <li [class.active]="activeTab == propertyTabs.Message"
              *ngIf="isUserLoggedIn && property.PropertyStatus != 'BOV' && property.PropertyStatus != 'Pre-Marketing'
                        && ((enableMessage && !authService.IsUserRole(this.authService.UserRole.Principal1031) && !authService.Seller())
                        || (property.HasOpenedExchange && authService.IsUserRole(this.authService.UserRole.Principal1031))
                        || (authService.Seller() && authService.IsUserRole(this.authService.UserRole.Principal1031) && property.HasOpenedExchange)
                        || (authService.Seller() && property.IsPropertyDashboardEnabled))">
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Message)">
              <span class="icon-chat icon"></span>Message
            </a>
          </li>
          <li class="btn-group" dropdown [autoClose]="true" container="body" *ngIf="(enableShare && property.PropertyForId !== 602)||(isUserLoggedIn&&(this.authService.IsUserRole(this.authService.UserRole.Admin)|| this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)||this.authService.IsUserRole(this.authService.UserRole.Broker))&&offeringMemorandomDocList.length > 0)" [class.active]="activeTab == propertyTabs.Share">
            <a id="button-nested" dropdownToggle class="btn dropdown-toggle"
               aria-controls="dropdown-nested">
              <span class="icofont icofont-share icon"></span> Share
            </a>
            <ul id="dropdown-nested" *dropdownMenu class="dropdown-menu"
                role="menu" aria-labelledby="button-nested">
              <li role="menuitem" *ngIf="isUserLoggedIn&&(this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)||this.authService.IsUserRole(this.authService.UserRole.Broker))"><a class="dropdown-item" (click)="openModalForShareOM(ShareOM,'portfolio-bov-modal shareom-document-modal propertyview-shareom');" *ngIf="offeringMemorandomDocList.length > 0" fragment="nested-dropdowns">Share OM</a></li>
              <li role="menuitem" dropdown triggers="mouseover" placement="right" container="body" *ngIf="enableShare && property.PropertyForId !== 602">
                <a dropdownToggle class="dropdown-item dropdown-toggle"
                   (click)="false">Share Listing <span class="caret"></span></a>
                <ul *dropdownMenu class="dropdown-menu" role="menu">
                  <li role="menuitem" *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)||this.authService.IsUserRole(this.authService.UserRole.Broker)"><a class="dropdown-item" href="javascript:void(0);" (click)="copyMessage()"><i class="fa fa-copy icons"></i> Copy Link</a></li>
                  <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openPropertyShareModal(propertyShare, 'panlestyle',propertyTabs.Share)"><i class="fa fa-envelope-o icons"></i> Email</a></li>
                  <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="shareOnSocialMedia(socialMedia.FB);"><i class="icon-facebook icons"></i> Facebook</a></li>
                  <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="shareOnSocialMedia(socialMedia.LinkedIn);"><i class="icon-linkedin icons"></i> LinkedIn</a></li>
                  <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="shareOnSocialMedia(socialMedia.Twitter);"><i class="icon-twitter icons"></i> Twitter </a></li>
                </ul>
              </li>
            </ul>
          </li>
          <!--<li [class.active]="activeTab == propertyTabs.Share" *ngIf="enableShare && property.PropertyForId !== 602">
              <a href="javascript:void(0);" (click)="openPropertyShareModal(propertyShare, 'panlestyle',propertyTabs.Share)">
                  <span class="icofont icofont-share icon"><i></i></span>Share Via Email
              </a>
          </li>-->
          <!--<li class="btn-group" dropdown container="body" [class.active]="activeTab == propertyTabs.Share" *ngIf="enableShare && property.PropertyForId !== 602">
            <a id="button-basic" dropdownToggle class="btn dropdown-toggle"
               aria-controls="dropdown-basic">
              <span class="icofont icofont-share icon"></span>Share
            </a>
            <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu socialsharelinks more-dropdown" role="menu" aria-labelledby="button-basic">
              <li role="menuitem" *ngIf="this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.Broker)"><a class="dropdown-item" href="javascript:void(0);" (click)="copyMessage()"><i class="fa fa-copy icons"></i> Copy Link</a></li>
              <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openPropertyShareModal(propertyShare, 'panlestyle',propertyTabs.Share)"><i class="fa fa-envelope-o icons"></i> Email</a></li>
              <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="shareOnSocialMedia(socialMedia.FB);"><i class="icon-facebook icons"></i> Facebook</a></li>
              <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="shareOnSocialMedia(socialMedia.LinkedIn);"><i class="icon-linkedin icons"></i> LinkedIn</a></li>
              <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="shareOnSocialMedia(socialMedia.Twitter);"><i class="icon-twitter icons"></i> Twitter </a></li>
            </ul>
          </li>-->

          <li class="btn-group" dropdown container="body" [class.active]="activeTab == propertyTabs.More" *ngIf="(viewActivityLog)||(viewNotifications)||(viewBrokerage && property.PropertyForId === 602)||(this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin))">
            <a id="button-basic" dropdownToggle class="btn dropdown-toggle"
               aria-controls="dropdown-basic">
              <!--<span class="icofont icofont-plus icon"></span>--><span class="fa fa-ellipsis-v icon"></span>More
            </a>
            <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu socialsharelinks more-dropdown dropdown-menu-right   " role="menu" aria-labelledby="button-basic">
              <li role="menuitem" *ngIf="viewActivityLog"><a class="dropdown-item" href="javascript:void(0);" (click)="onTabClick(propertyTabs.ActivityLog)"><i class="icon-file-text icons"></i> Activity Log</a></li>
              <li role="menuitem" *ngIf="viewBrokerage && property.PropertyForId === 602"><a class="dropdown-item" href="javascript:void(0);" (click)="onTabClick(propertyTabs.Brokerage)"><i class="icon-presentation icons"></i> Brokerage</a></li>
              <li role="menuitem" *ngIf="viewNotifications"><a class="dropdown-item" href="javascript:void(0);" (click)="onTabClick(propertyTabs.Notifications)"><i class="icon-file-text icons"></i>Notifications</a></li>
              <!--<li role="menuitem" *ngIf="this.user.RoleId === (this.authService.UserRole.Admin)"><a class="dropdown-item" href="javascript:void(0);" (click)="onTabClick(propertyTabs.Duplicates)"><i class="icon-file-document icons"></i> Duplicates </a></li>-->
            </ul>
          </li>

          <!--<li [class.active]="activeTab == propertyTabs.ActivityLog" *ngIf="viewActivityLog">
              <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.ActivityLog)">
                  <span class="icofont icofont-file-text icon"></span>Activity Log
              </a>
          </li>
          <li [class.active]="activeTab == propertyTabs.Brokerage" *ngIf="viewBrokerage && property.PropertyForId === 602">
              <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Brokerage)">
                  <span class="icofont icofont-presentation icon"></span>Brokerage
              </a>
          </li>
          <li [class.active]="activeTab == propertyTabs.Duplicates" *ngIf="this.user.RoleId === (this.authService.UserRole.Admin)">
              <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Duplicates)">
                  <span class="icofont icofont-file-document icon"></span>Duplicates
              </a>
          </li>-->
        </ul>
        <a href="{{currentsharedurl}}" id="copyurl" style="display: none;"><h4 style="color: rgb(17,85,204) !important; text-decoration-line: underline; font-size:13px !important;font-family:Poppins,sans-serif !important; ">{{currentsharedtext}}</h4></a>

      </div>
      <!--<div class="leftside" style="text-align:right">
          <tweet url={{currentUrl}} text=''></tweet>
          <linkedin-share url="{{currentUrl}}"></linkedin-share>
      </div>-->
      <div class="row">
        <!--Dashboard start here-->
        <div class="col-md-12">
          <div class="border-div" *ngIf="activeTab == propertyTabs.Dashboard">
            <app-property-dashboard [propertyGuid]="propertyGuid" [AccessAdded]="accessAdded" [propertyId]="propertyId" [IsPortfolio]="property.IsPortfolio" [property]="property" (viewPlaceOffer)="viewPlaceOffer($event)"></app-property-dashboard>
          </div>
        </div>

        <!--Dashboard End here-->
        <!--Home Start here-->
        <div class="leftside" *ngIf="activeTab !=propertyTabs.PlaceOffer">

          <div *ngIf="activeTab == propertyTabs.Home">
            <div class="border-div">
              <div class="clearfix">
                <div class="data-right">
                  <h3>
                    {{property.Tenant}}
                    <a href="javascript:void(0);" [ngClass]="{'disable-link':property.IsDeleted}" *ngIf="property.HasDuplicates && (authService.Admin() || authService.SuperAdmin() || authService.Broker())" class="blueone" tooltip="View Duplicates" (click)="openModalForDuplicates(DuplicateProperty,'panlestyle',property.Id)" placement="top" style="line-height:32px;">
                      <i class="fa fa-files-o" style="font-size:18px;" aria-hidden="true"></i>
                    </a>
                    <span class="status" [ngClass]="{'red':(property.PropertyStatus === 'Closed' || property.PropertyStatus === 'Sold'),
                                                                         'green':property.PropertyStatus === 'Available',
                                                                         'blue':property.PropertyStatus === 'Not Available',
                                                                         'orange':property.PropertyStatus === 'Under Contract','ash':property.PropertyStatus === 'Off-Market','d-orange':property.PropertyStatus === 'Pending Approval'}">{{property.PropertyStatus}}</span>
                    <button class="warningsymbol" *ngIf="property.IsSourceChanged ===1 && (this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin))" container="body" triggers="hover" popover="There is an update in the property source."><i style="margin:0px 0px 0px -3px !important" class="icon icon-warning"></i></button>

                  </h3>
                  <h6 *ngIf="haveaccesstoviewlocation">{{property.FullAddress && (property.FullAddress.length > 5) ? property.FullAddress:''}}</h6>
                  <h6 *ngIf="!haveaccesstoviewlocation">Confidential</h6>
                  <sub class="pro-id">#{{property.PropertySequenceId}}</sub>
                  <br />
                  <a href="javascript:void(0);" [ngClass]="{'disable-link':property.IsDeleted}" *ngIf="property.ParentPortfolioName" class="btn-border btn-view-portfolio " (click)="onViewProperty(property.ParentPortfolioGuid)" style="cursor:pointer;">
                    View Portfolio
                  </a>
                  <!--<div class="floated-btn">
                <button *ngIf="isUserLoggedIn && canEditProperty && canEditPropertyForBroker" class="btn  btn-circle btn-green" ng-reflect-placement="top" ng-reflect-tooltip="Edit"
                        placement="top" tooltip="Edit" (click)="onEditPropertyClick();">

                    <i aria-hidden="true" class="icofont icofont-ui-edit icon"></i>
                </button>
                <button *ngIf="isUserLoggedIn &&  (this.user.RoleId == this.authService.UserRole.Admin || this.user.RoleId == this.authService.UserRole.DataEntryStaff)" class="btn  btn-circle btn-verify" ng-reflect-placement="top" ng-reflect-tooltip="Edit"
                        placement="top" tooltip="Verify Property" (click)="VerifyProperty(property.Id)">
                    <i aria-hidden="true" class="icofont icofont-ui-check"></i>
                </button>
            </div>-->
                  <div class="like-view-div" *ngIf="showLikesAndViews">
                    <p>Likes<span>{{property.LikesCount ? (property.LikesCount|number) :'-'}}</span></p>

                    <!--<p>Views<span>{{property.ViewsCount ? (property.ViewsCount|number) :'-'}}</span></p>-->

                  </div>


                </div>
              </div>

            </div>
            <app-property-notes *ngIf="showNotes" [propertyId]="propertyId" [IsPDeleted]="property.IsDeleted"></app-property-notes>
            <!--Showing portfolio Details Starts here-->
            <div class="border-div property-details-box" *ngIf="property?.IsPortfolio">
              <h2 class="mainhead">
                <span class="text">
                  Portfolio Details
                </span>
              </h2>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Type</label>
                    <h6 class="displayvalue" tooltip="{{property.AssetType}}">{{property.AssetType ? commonService.GetPropertyTypeWithCount(property.AssetType) :  '-'}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Subcategory</label>
                    <h6 class="displayvalue" tooltip="{{property.Subcategory}}">{{property.Subcategory ? commonService.GetPropertyTypeWithCount(property.Subcategory) : '-'}}</h6>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Total Portfolio</label>
                    <h6 class="displayvalue">{{property.BuildingSize && property.BuildingSize != 0 ? (property.BuildingSize | number) + ' SF' : '-'}}</h6>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Total Land</label>
                    <h6 class="displayvalue">{{property.Land && property.Land != 0 ? (property.Land | number :'1.2-2') + ' AC' : '-'}}</h6>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Net Operating Income</label>
                    <h6 class="displayvalue">
                      {{property.NetOperatingIncome && property.NetOperatingIncome !== 0 ? '$' + (property.NetOperatingIncome | number:0) : '-'}}
                    </h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Avg. Remaining Term</label>
                    <h6 class="displayvalue">
                      {{property.PortfolioRemainingLeaseTerm ? (property.PortfolioRemainingLeaseTerm) :'-'}}
                    </h6>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Lease Structure</label>
                    <h6 class="displayvalue">{{property.LeaseStructure ? property.LeaseStructure : '-'}}</h6>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="property.ShowRentEscalation">
                  <div class="form-group">
                    <label class="blocklabel">Rent Escalations</label>
                    <h6 class="displayvalue">{{property.RentEscalations}}</h6>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="property.ShowOptions">
                  <div class="form-group">
                    <label class="blocklabel">Options</label>
                    <h6 class="displayvalue">
                      {{
 (property.Options ? property.Options : '') +(property.OptionLength && property.Options ? ', ' : '') +
                                            (property.OptionLength ? property.OptionLength + ' ' : '') +
                                            (property.OptionLength ? '-' : '') +
                                            (property.OptionLength ? (property.OptionLength > 1 ? ' Year(s)' : ' Year(s)') : '')
                      }}
                    </h6>
                  </div>
                </div>

              </div>

              <div *ngIf="property.Description" class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="form-group">
                    <label class="bluelabel margin-bottom-10">About the Property</label>
                    <p class="para prewrap">{{ property.Description }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!--Showing portfolio Details Ends here-->

            <div class="border-div property-details-box" *ngIf="!property.IsPortfolio">
              <h2 class="mainhead">
                <span class="text">Property Details</span>
              </h2>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group" style="display:inline-block;">
                    <label class="blocklabel">Property Type</label>
                    <h6 class="displayvalue" tooltip="{{property.AssetType}}">{{property.AssetType ? commonService.GetPropertyTypeWithCount(property.AssetType) : '-'}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Subcategory</label>
                    <h6 class="displayvalue" tooltip="{{property.Subcategory}}">{{property.Subcategory ? commonService.GetPropertyTypeWithCount(property.Subcategory): '-'}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Rating</label>
                    <h6 class="displayvalue">{{property.Rating}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Lease Structure</label>
                    <h6 class="displayvalue">{{property.LeaseStructure ? property.LeaseStructure : '-'}}</h6>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Guarantor</label>
                    <h6 class="displayvalue">{{property.Guarantor ? property.Guarantor : '-'}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Ownership Type</label>
                    <h6 class="displayvalue">{{property.OwnershipType ? property.OwnershipType : '-'}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Net Operating Income</label>
                    <h6 class="displayvalue">
                      {{property.NetOperatingIncome && property.NetOperatingIncome !== 0 ? '$' + (property.NetOperatingIncome| number:0) : '-'}}
                    </h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Remaining Term</label>
                    <h6 class="displayvalue">
                      {{property.Remaining_Term ? (property.Remaining_Term) :'-'}}
                    </h6>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Rent Escalations</label>
                    <h6 class="displayvalue">{{property.RentEscalations}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Options</label>
                    <h6 class="displayvalue">
                      {{
                                            (property.Options ? property.Options : '') +
                                            (property.OptionLength && property.Options ? ', ' : '') +
                                            (property.OptionLength ? property.OptionLength + ' ' : '') +
                                            (property.OptionLength ? '-' : '') +
                                            (property.OptionLength ? (property.OptionLength > 1 ? ' Year(s)' : ' Year(s)') : '')
                      }}
                    </h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Year Built</label>
                    <h6 class="displayvalue">{{property.YearBuilt && property.YearBuilt != 0 ? property.YearBuilt : '-'}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Building Size</label>
                    <h6 class="displayvalue">{{property.BuildingSize && property.BuildingSize != 0 ? (property.BuildingSize | number) + ' SF' : '-'}}</h6>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Land</label>
                    <h6 class="displayvalue">{{property.Land && property.Land != 0 ? (property.Land | number :'1.2-2') + ' AC' : '-'}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <div class="form-group">
                      <label class="blocklabel">Property Characteristics</label>
                      <h6 class="displayvalue">{{characterstics}}</h6>
                    </div>
                  </div>
                </div>
              </div>

              <!--<h2 *ngIf="property.Description" class="mainhead">
                <span class="text">About the Property</span>
        </h2>-->
              <div *ngIf="property.Description" class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="form-group">
                    <label class="bluelabel margin-bottom-10">About the Property</label>
                    <p class="para prewrap">{{ property.Description }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="border-div">
              <h2 class="mainhead">
                <span class="text">Investment Highlights</span>
              </h2>
              <ul class="highlights" *ngIf="property.PropertyHighlightsList && property.PropertyHighlightsList != undefined && property.PropertyHighlightsList.length > 0">
                <li *ngFor="let item of property.PropertyHighlightsList">
                  <i class="icon-tick icon"></i>
                  <h5>{{item.Title}}</h5>
                  <p *ngIf="isDescriptionVisible">{{item.Description}}</p>
                </li>
              </ul>
              <div class="text-right" *ngIf="property.PropertyHighlightsList && property.PropertyHighlightsList != undefined && property.PropertyHighlightsList.length > 0">
                <a href="javascript:void(0);" class="bluelink" (click)="onToggleDescriptionVisibility()">{{toggleDetailsText}}</a>
              </div>
              <div class="nodata" *ngIf="!property.PropertyHighlightsList || property.PropertyHighlightsList == undefined || property.PropertyHighlightsList.length == 0">
                <!--<i class="icofont icofont-warning icon"></i>-->
                <p>Investment Highlights are coming soon!</p>
              </div>
            </div>
            <div class="border-div" *ngIf="property.IsShowRentSchedule && !property.IsPortfolio">
              <div class="floatinghead clearfix">
                <h2 class="mainhead">
                  <span class="text">NOI / Rent Schedule</span>
                </h2>
                <!--<div class="rightcheckbox">
              <label class="custom-checkbox " for="checkbox12">
                  <input formControlName="chkRentTermAutoCalc" [(ngModel)]="model.IsRentTermAutoCalc" id="checkbox12" type="checkbox" (ngModelChange)="propertyRentTermsFielsChange()"> Auto populate Rent Schedule
                  <i></i>
              </label>
          </div>-->
              </div>
              <div class="rent-schedule-table">
                <app-rent-term-table [propertyId]="propertyId" [InitialLoad]="true" [IsEditAllowed]="false"></app-rent-term-table>
              </div>
            </div>
            <!--Showing portfolio property list Starts Here-->
            <div class="border-div" *ngIf="property.IsPortfolio || property.ParentPortfolioName">
              <div class="floatinghead floatinghead-xs clearfix">
                <div class="clearfix p-1">
                  <div class="floatinghead floatinghead-xs clearfix">
                    <div class="pull-left"><h2 class="mainhead"><span class="text">Portfolio Properties</span></h2></div>
                    <div class="pull-right clearfix">
                      <button class="btn-border margin-right-10 btn adduserbtn pull-right margin-bottom-15" *ngIf="propertiesEx?.length !== 0 " [disabled]="property.IsDeleted" (click)="exportToExcel();">Export To Excel</button>
                      <div class="select-dropdown multiselectdesign pull-right multi-check-dropdown margin-right-10">
                        <mat-form-field>
                          <mat-select placeholder="Select Columns"
                                      [(ngModel)]="selectedColumns"
                                      multiple>
                            <mat-select-trigger>
                              <span>Select Columns</span>
                            </mat-select-trigger>
                            @for (column of tableColumns; track column) {
                            <mat-option [value]="column.id" class="multi-dropdown-item">{{column.name}}</mat-option>
                            }
                            @if (tableColumns.length === 0) {
                            <mat-option class="matoptionnodata" disabled>
                              Nothing found...
                            </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                  <thead>
                    <tr>
                      <th class="remove" style="position:static; cursor:default" ng-disabled="true" data-orderable="false"></th>
                      <th class="sticky-left" style="width:50px !important">Property Id</th>
                      <th class="whitespacenowrap sticky-left">Tenant Name</th>
                      <th [hidden]="hideColumn(1)">OM</th>
                      <th [hidden]="hideColumn(2)">State</th>
                      <th class="whitespacenowrap" [hidden]="hideColumn(3)">City</th>
                      <!--<th [hidden]="hideColumn(4)">Property Type</th>-->
                      <th [hidden]="hideColumn(5)">Status</th>
                      <th [hidden]="hideColumn(6)">Asking Price</th>
                      <th [hidden]="hideColumn(7)">Rent / NOI</th>
                      <th class="whitespacenowrap" [hidden]="hideColumn(8)">Cap Rate</th>
                      <th class="whitespacenowrap" [hidden]="hideColumn(9)">Rem. Term</th>
                      <th [hidden]="true">Rank</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let prop of portfolioProperties;let i = index">
                      <td [ngClass]="{'be-list': (prop.PropertyForId == 601 )}">
                        <a href="#" routerLink="/viewproperty/{{prop.Guid}}" (click)="onRedirection();" [queryParams]="{prevroute:'Live Listings',link:router.url}">
                          <div class="property-image" *ngIf="prop.FilePath !=null" [ngStyle]="{'background-image': 'url(' + prop.FilePath + ')'}"></div>
                          <div class="property-image" *ngIf="prop.FilePath == null" style="background-image:url(../../assets/img/default-property_1.png)"></div>
                        </a>
                      </td>
                      <td class="sticky-left" style="width:50px !important">
                        <p>
                          {{ prop.PropertySequenceId }}
                        </p>
                      </td>
                      <td class="sticky-left">
                        <p>
                          <a href="#" routerLink="/viewproperty/{{prop.Guid}}" (click)="onRedirection();" [queryParams]="{prevroute:'Live Listings',link:router.url}">{{ prop.PropertyName }}</a>
                        </p>
                      </td>
                      <td [hidden]="hideColumn(1)">
                        <a *ngIf="prop.OMFilePath!=null" (click)=" OnPortfolioOMDownload(prop.Guid)" [ngClass]="{'border-link':(prop.OMFilePath!=null)}">
                          <i *ngIf="prop.OMFilePath!=null" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{prop.OMFilePath!=null?'OM':'-'}}
                        </a>
                      </td>
                      <td [hidden]="hideColumn(2)"><p>{{prop.State ? prop.State : '-'}}</p></td>
                      <td class="whitespacenowrap" [hidden]="hideColumn(3)"><p>{{prop.City ? prop.City : '-'}}</p></td>

                      <td [hidden]="hideColumn(5)"><p [ngClass]="{'redtextlabel':(prop.PropertyStatus === 'Closed' || prop.PropertyStatus === 'Sold'),'greentextlabel':prop.PropertyStatus === 'Available','orangetextlabel':prop.PropertyStatus === 'Under Contract','not-available':prop.PropertyStatus === 'Not Available','Off-Market':prop.PropertyStatus === 'Off-Market'}">{{ prop.PropertyStatus }}</p></td>
                      <td [hidden]="hideColumn(6)">
                        <p *ngIf="!prop.Unpriced" class="whitespacenowrap">{{(prop.Price) ? '$ '+ (prop.Price | number:0) : '-'}}</p>
                        <p *ngIf="prop.Unpriced" class="whitespacenowrap">Unpriced</p>
                      </td>
                      <td [hidden]="hideColumn(7)"><p class="whitespacenowrap">{{(prop.RentNOI) ? '$ '+ (prop.RentNOI | number:0) : '-'}}</p></td>
                      <td [hidden]="hideColumn(8)">
                        <p *ngIf="prop.CharacteristicsId == 1">ZCF</p>
                        <p *ngIf="prop.CharacteristicsId == 0">{{ (prop.CapRate) ? (prop.CapRate | number : '1.2-2') + '%' : '-' }}</p>
                      </td>
                      <td class="whitespacenowrap" [hidden]="hideColumn(9)"><p>{{ prop.RemainingTerm ? (prop.RemainingTerm | yearsMonthConverter:true) : '-' }}</p></td>
                      <td [hidden]="true"><p>{{ prop.Rank }}</p></td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr *ngIf="properties?.length == 0 ">
                      <td colspan="10" class="odd no-data-available">
                        <div class="nodata">
                          <i class="fa fa-exclamation-triangle icon"></i>
                          <p>No Data Available</p>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <!--Showing portfolio property list end here-->

          </div>
        </div>
        <div class="rightside clearfix" *ngIf="activeTab ==propertyTabs.Home">
          <div class="halfwidth1100 hidden-xs">
            <div class="border-div pb-0">
              <div class="askingprice mb-0">
                <span class="two_sep">
                  <h3>
                    <span>Asking Price</span>
                    <span *ngIf="property.Unpriced">Unpriced</span>
                    <span *ngIf="!property.Unpriced">{{(property.IsShowPrice) ? '$ '+(property.Price | number:0) : '-'}}</span>
                  </h3>
                </span>
                <span class="right_cont two_sep">
                  <h3 class="pricedetails">
                    <span>Cap Rate</span>
                    <span *ngIf="capratetext == 'ZCF'">{{capratetext}}</span>
                    <span *ngIf="capratetext != 'ZCF'">{{ (property.CapRate && property.IsShowPrice) ? (property.CapRate | number : '1.2-2') + ' %' : '--' }}</span>
                  </h3>
                </span>
              </div>
            </div>
          </div>

          <div class="halfwidth1100" *ngIf="showContactUs && property.PropertyContactPersonsList && property.PropertyContactPersonsList != undefined && property.PropertyContactPersonsList.length > 0">
            <div class="border-div ">
              <h2 class="mainhead">
                <span class="text">Contact Us</span>
              </h2>
              <ul class="contacts" *ngIf="property.PropertyContactPersonsList && property.PropertyContactPersonsList != undefined && property.PropertyContactPersonsList.length > 0">
                <li class="clearfix" *ngFor="let item of property.PropertyContactPersonsList">
                  <div *ngIf="item.ContactTypeId != contactType.Others">
                    <div class="imgblock">
                      <img [src]="item.Photo != '' ? item.Photo : defaultProfilePic">
                    </div>
                    <div class="data">
                      <h3>{{item.Name}}<span *ngIf="item.ContactTypeId == contactType.Primary"> - Primary</span></h3>
                      <p>
                        <i class="icon-phone icon"></i>{{item.PhoneNo | phone}}
                      </p>
                      <p>
                        <i class="icon-message icon"></i>{{item.EmailID}}
                      </p>
                      <p *ngIf="item.License != null && item.License != ''">
                        <i class="icon-license icon"></i>{{item.License}}
                      </p>

                      <ul class="d-flex social-links padding0 margin-top-10 margin-bottom-10">
                        <li>
                          <a *ngIf="item.UserLinkedInProfile != null && item.UserLinkedInProfile != ''" target="_blank" href="{{item.UserLinkedInProfile}}"><i class="icon fa fa-linkedin-square" aria-hidden="true"></i></a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="nodata" *ngIf="!property.PropertyContactPersonsList || property.PropertyContactPersonsList == undefined || property.PropertyContactPersonsList.length == 0">
                <i class="icofont icofont-warning icon"></i>
                <p>No Data Available</p>
              </div>
              <div class="text-center" *ngIf="property.PropertyStatus === 'Available' && property.PropertyForId === 601 && (authService.Principal() || authService.Principal1031() || authService.ExternalBroker()) ">
                <button class="btn btn-success btn-lg btn-send-inquiry" id="btnSentInquiry" (click)="openInquiryModal(template,'panlestyle')">
                  Send Inquiry
                </button>
              </div>
              <h5 *ngIf="property.PropertyContactPersonsList && property.PropertyContactPersonsList != undefined && property.PropertyContactPersonsList.length > 0">
                <span *ngIf="hasOtherContactType">
                  In Association with
                </span>
                <div *ngFor="let item of property.PropertyContactPersonsList">
                  <div *ngIf="item.ContactTypeId == contactType.Others">
                    {{item.Name}} {{item.License}}
                  </div>
                </div>
              </h5>
            </div>
            <div class="border-div ">
              <h2 class="mainhead">
                <span class="text">Follow B+E on Social</span>
              </h2>
              <ul class="d-flex social-links padding0 margin-top-10 margin-bottom-10">
                <li>
                  <a target="_blank" class="margin-left-10" href="https://www.linkedin.com/company/benetlease"><i class="fa fa-linkedin-square" aria-hidden="true"></i></a>
                </li>
                <li>
                  <a target="_blank" class="margin-left-10" href="https://www.facebook.com/BeNetLease"><i class="fa fa-facebook-square" aria-hidden="true"></i></a>
                </li>
                <li>
                  <a class="margin-left-10" target="_blank" href="https://twitter.com/BeNetLease"><i class="fa fa-twitter-square" aria-hidden="true"></i></a>
                </li>
                <li> <a class="margin-left-10" target="_blank" href="https://www.instagram.com/benetlease/?igshid=N2ZiY2E3YmU%3D"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
              </ul>
            </div>

          </div>
          <div class="halfwidth1100" *ngIf="property.PropertyForId != 601 && property.BrokerList && property.BrokerList != undefined && property.BrokerList.length > 0 && (authService.Admin()|| authService.SuperAdmin() || authService.Broker())">
            <div class="border-div ">
              <h2 class="mainhead">
                <span class="text">Brokers - {{property.BrokerList[0].BrokerageName}}</span>
              </h2>
              <ul class="contacts" *ngIf="property.BrokerList && property.BrokerList != undefined && property.BrokerList.length > 0">
                <li class="clearfix" *ngFor="let item of property.BrokerList">
                  <div>
                    <div class="data">
                      <h3>{{item.BrokerName}}</h3>
                      <p>
                        <i class="fa fa-address-card-o icon" aria-hidden="true"></i>{{item.Title}}
                      </p>
                      <p>
                        <i class="icon-phone icon"></i>{{item.Phone | phone}}
                      </p>
                      <p>
                        <i class="icon-message icon"></i>{{item.Email}}
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="nodata" *ngIf="!property.BrokerList || property.BrokerList == undefined || property.BrokerList.length == 0">
                <i class="icofont icofont-warning icon"></i>
                <p>No Data Available</p>
              </div>
            </div>
          </div>
          <div class="halfwidth1100 hidden-xs" *ngIf="property.VerifiedUser">
            <div class="border-div pb-0">
              <div class="mb-0">
                <span style="float: left; margin-right: 10px;">
                  <span class="btn  btn-circle btn-verify" style="background-color: green; color: white;cursor:auto" ng-reflect-placement="top" ng-reflect-tooltip="Edit"
                        placement="left">
                    <i aria-hidden="true" class="icofont icofont-ui-check"></i>
                  </span>
                </span>
                <span class="two_sep">
                  <h4>Verified and Available</h4>
                  <h6>
                    {{property.VerifiedUser}} ,

                    {{property.VerifiedDate ? (Validation.formatDate(Validation.convertUTCDateToLocalDate(property.VerifiedDate), 'MM/dd/yyyy')) : '-'}}
                  </h6>

                  <span>
                    {{property.VerifiedNote}}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="text-center" *ngIf="property.PropertyStatus === 'Available' && property.PropertyForId === 601 && !property.IsPortfolio && property.PropertyContactPersonsList?.length === 0 && (authService.Principal() || authService.Principal1031() || authService.ExternalBroker())">
            <button class="btn btn-success btn-lg btn-send-inquiry" id="btnSentInquiry" (click)="openInquiryModal(template,'panlestyle')">
              Send Inquiry
            </button>
          </div>
        </div>
        <!--Home Ends here-->
        <!--Offering Memorandom Start here-->
        <div class="col-md-12">
          <div class="border-div" *ngIf="activeTab == propertyTabs.Memorandom">
            <div class="d-flex filter-header-rt floatinghead clearfix">
              <div class="rightside d-flex ml-auto">
                <a id="button-basic" class="filter btn btn-adduser btn-circle btn-green adduserbtn ml-auto nav-notification" (click)="OpenAddUserSlider(addUsers, 'panlestyle')"
                   aria-controls="dropdown-basic" style="font-size:18px;" *ngIf="(((authService.Broker()&&accessAdded==1) || authService.Admin()|| authService.SuperAdmin())&&property.OfferMemoReqApproval)" href="javascript:void(0);" placement="left" tooltip="Add User">
                  <span class="fa fa-user-plus"></span>
                  <sup class="duedilegencecount btn-circle ml-auto" *ngIf="OMUserCount > 0">{{OMUserCount > 99 ? '99+':OMUserCount}}</sup>
                </a>

                <!--<a id="button-basic" class="filter btn btn-adduser btn-circle btn-green adduserbtn ml-auto nav-notification" (click)="OpenAddUserSlider(addUsers, 'panlestyle')"
             aria-controls="dropdown-basic" style="font-size:18px;" *ngIf="(((authService.Broker()&&AccessAdded==1) || authService.Admin())&&(propertyId!=null&&propertyId!=0&&!showCAAcceptPending && !pendingApproval && !ddRequireApproval && !ddRequestRejected) || isfromSearch)" href="javascript:void(0);" placement="left" tooltip="Add User to DD">
            <span class="fa fa-user-plus"></span>
            <sup class="duedilegencecount btn-circle ml-auto" *ngIf="docAccessUserCount > 0">{{docAccessUserCount > 99 ? '99+':docAccessUserCount}}</sup>
          </a>-->
              </div>
            </div>
            <div class="nodata" *ngIf="showNodataOM">

              <!--<i class="icofont icofont-warning icon"></i>-->
              <!--<p>No Data Available</p>-->
              <p>Offering Memorandum is coming soon! Contact Broker for more details.</p>
            </div>

            <!--<div class="table-responsive" *ngIf="offeringMemorandomDocList != null && offeringMemorandomDocList.length > 0 && (docAccessOutput.RequestForOfferAccessId == docAccessStatus.Accepted || canEditProperty || (property.ConfidentialityAgreement != true || property.OfferMemoReqApproval  != true || docAccessOutput.IsCAAccepted == true))">-->
            <div class="table-responsive" *ngIf="showHideMessages(1,2);">
              <table class="table basictable">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Document Name</th>
                    <th>Date</th>
                    <th>Category</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of offeringMemorandomDocList; let i = index" [class.highlighted]="i == 0">
                    <td>
                      <p>{{i+1}}</p>
                    </td>
                    <td>
                      <a *ngIf="isUserLoggedIn" onMouseOver="this.style.color='#198fde'"
                         onMouseOut="this.style.color='#616161'" href={{item.FilePath}} target="_blank"
                         (click)="saveOfferingMemorandomToAuditLog(item.Id)">
                        {{item.Name}}
                      </a>
                      <a href='#' onMouseOver="this.style.color='#198fde'"
                         onMouseOut="this.style.color='#616161'" *ngIf="isUserLoggedIn==false"
                         (click)="saveOfferingMemorandomToAuditLog(item.Id)">
                        {{item.Name}}
                      </a>
                      <!--<a href='#' ng-reflect-placement="top" target="_blank" (click)="saveOfferingMemorandomToAuditLog()">
                {{item.Name}}</a>-->


                    </td>
                    <td>


                      <p>



                        {{item.UploadedDate ? (Validation.formatDate(Validation.convertUTCDateToLocalDate(item.UploadedDate), 'MM/dd/yyyy')) : '-'}}
                      </p>
                    </td>
                    <td>
                      <p>{{item.Category}}</p>
                    </td>
                    <td>
                      <a class="view" *ngIf="isUserLoggedIn" href={{item.FilePath}} target="_blank" placement="top" tooltip="Download" ng-reflect-tooltip="Download"
                         ng-reflect-placement="top" triggers="hover" (click)="saveOfferingMemorandomToAuditLog(item.Id)">
                        <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                      </a>
                      <a class="view" href='#' *ngIf="isUserLoggedIn==false" placement="top" tooltip="Download" ng-reflect-tooltip="Download"
                         ng-reflect-placement="top" triggers="hover" (click)="saveOfferingMemorandomToAuditLog(item.Id)">
                        <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                      </a>
                      <a *ngIf="item.FilePath.includes('.pdf')" href="javascript:void(0);" tooltip="Preview" (click)="previews(preview,'pdf-view-modal', item,item.Id)" placement="top">
                        <i aria-hidden="true" class="fa fa-eye"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="property.ConfidentialityAgreement && docAccessOutput.IsCAAccepted != true">
              <div *ngIf="showHideMessages(1,3)">
                <div id="agreement">
                  <app-nda-agreement [ndaDetails]="ndaDetails"></app-nda-agreement>
                </div>
                <div class="margin-top-30">
                  <label class="custom-checkbox" for="checkboxTerms">
                    <input class="border-checkbox" id="checkboxTerms" type="checkbox" [(ngModel)]="isMemorandomTandC">
                    <i class="helper"></i>I agree to the above terms and conditions
                  </label>
                </div>
                <div class="text-right">
                  <button class="btn btn-success btn-lg" [disabled]="!isMemorandomTandC" (click)="onMemorandomProceedClick()">
                    Proceed
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="(!property.ConfidentialityAgreement || docAccessOutput.IsCAAccepted == true) && property.OfferMemoReqApproval && (authService.Principal1031() || authService.ExternalBroker() || authService.Principal())">
              <div class="nodata" *ngIf="showHideMessages(1,4)">
                <p>
                  <span class="text">
                    Offering Memorandum download requires Broker approval. <a class="blue-text" (click)="onMemorandomProceedClick()">Click here</a> to request access.
                  </span>
                </p>
              </div>
            </div>

            <div *ngIf="showHideMessages(1,5)">
              <h2 class="mainhead">
                <span class="text">
                  Pending Approval
                </span>
              </h2>
              Your download request is being processed. The documents will be available for download soon.
            </div>
            <div *ngIf="showHideMessages(1,6)">
              <h2 class="mainhead">
                <span class="text">
                  Request Rejected
                </span>
              </h2>
              <div>
                Your request to view the Offering memorandum document has been rejected. Please get in touch with us to know more.
                <br />
                <b>Call : 646-770-0659</b>
                <br />
                <b>Email : info&#64;tradenetlease.com</b>
              </div>
            </div>
          </div>
          <!--<div class="border-div" *ngIf="(!showNodataOM || !showNodataDD || property.OfferMemoReqApproval || property.DueDiligenceReqApproval || property.ConfidentialityAgreement) && this.visewDocRequestList==true && activeTab == propertyTabs.Memorandom">
      <doc-access-listing [property]="property"></doc-access-listing>
    </div>-->
        </div>
        <!--Offering Memorandom Ends here-->
        <!--Inquiries Start here-->
        <div class="col-md-12">
          <div *ngIf="canEditProperty && activeTab == propertyTabs.Inquiries">
            <property-inquiries-list [propertyGuid]="propertyGuid"></property-inquiries-list>
            <br />
          </div>
        </div>
        <!--Comps Start here-->
        <div class="col-md-12">
          <div *ngIf="activeTab == propertyTabs.Comps">
            <app-property-comps [propertyId]="propertyId" [property]="property" [IsPDeleted]="property.IsDeleted" [YearBuilt]="property.YearBuilt" [canEditHistory]="canEditHistory"></app-property-comps>
            <br />
          </div>
        </div>
        <!--Comps End here-->
        <!--Analytics Start here-->
        <div class="col-md-12">
          <div *ngIf="activeTab == propertyTabs.Analytics">
            <app-analytics [tenantId]="property.TenantId" [propertyId]="property.Id" [property]="property"></app-analytics>
            <br />
          </div>
        </div>
        <!--Analytics Ends here-->
        <!--Due Diligence Start here-->
        <div class="col-md-12">
          <div *ngIf="activeTab == propertyTabs.Diligence">
            <app-dd-list [propertyId]="property.Id" [property]="property" [AccessAdded]="accessAdded" [canEditProperty]="canEditProperty" [docAccessStatus]="docAccessStatus"></app-dd-list>
            <br />
          </div>
        </div>
        <!--Due Diligence End here-->
        <!--Offer list Start here-->
        <div class="col-md-12">
          <div *ngIf="canEditProperty && activeTab == propertyTabs.Offer">
            <property-offers-list (showOffer)="showOffer($event)" [propertyGuid]="propertyGuid"></property-offers-list>
          </div>
        </div>
        <!--Offer list End here-->
        <!--Offer list Start here-->
        <div class="col-md-12">
          <div *ngIf="activeTab == propertyTabs.OfferDetail">
            <property-offers-list (showOffer)="showOffer($event)" [propertyGuid]="propertyGuid"></property-offers-list>
          </div>
        </div>
        <!--Offer list End here-->
        <!--Place offer Start here-->
        <!--[ngClass]="{'show':activeTab == propertyTabs.PlaceOffer,'hide':activeTab != propertyTabs.PlaceOffer}"-->
        <div id="divPlaceOfferParent" *ngIf="activeTab == propertyTabs.PlaceOffer && !property.IsPortfolio">
          <place-offer [inputOfferGuid]="propertyGuid" [propType]="property.PropertyForId" [IsFromPropertyView]="true" [fromOfferMatrix]="fromOfferMatrix"></place-offer>
        </div>
        <div id="divPlaceOfferParent" *ngIf="activeTab == propertyTabs.PlaceOffer && property.IsPortfolio">
          <app-portfolio-place-offer [property]="property" [propertyGuid]="propertyGuid" [propType]="property.PropertyForId" [IsFromPropertyView]="true" [fromOfferMatrix]="fromOfferMatrix"></app-portfolio-place-offer>
        </div>
        <!--Place offer Ends here-->

        <div id="divPortfolioAnalysis" *ngIf="activeTab == propertyTabs.OfferAnalytics && property.IsPortfolio">
          <app-property-comparison [isPropertyAnalysis]="false" [isFromViewPage]="true"></app-property-comparison>
        </div>
        <!--Message Start here-->
        <div id="divMessageParent" *ngIf="activeTab == propertyTabs.Message">
          <div class="col-md-12">
            <app-messages-view [propertyGuid]="propertyGuid" [IsPDeleted]="property.IsDeleted" [isFromProperty]="true"></app-messages-view>
          </div>
        </div>
        <!--Message Ends here-->
        <!--Audit trail Start here-->
        <div id="divMessageParent" class="margin-bottom-40 cf property-log-wrap" *ngIf="activeTab == propertyTabs.ActivityLog">
          <div class="col-md-12">
            <app-audit-trail [getPropertyId]="property.Id" [propertyView]="true"></app-audit-trail>
          </div>
        </div>
        <div id="divMessageParent" class="margin-bottom-40 cf property-log-wrap clearfix" *ngIf="activeTab == propertyTabs.Notifications">
          <div class="col-md-12">
            <div class="border-div margin0 min-heightcontainer property-more-details-box notification-padding">
              <app-users-notifications [propertyId]="property.Id" [propertyView]="true"></app-users-notifications>
            </div>
          </div>
        </div>
        <!--Audit trail Ends here-->
        <!--Brokerage Start here-->
        <div *ngIf="activeTab == propertyTabs.Brokerage">
          <div class="col-md-12">
            <app-property-brokerage [propertyId]="property.Id"></app-property-brokerage>
          </div>
        </div>
        <!--Brokerage Ends here-->
        <!--Duplicate property Start here-->
        <!--<div *ngIf="activeTab == propertyTabs.Duplicates">
      <div class="col-md-12">
          <app-property-duplicates [PropertyId]="property.Id" [Type]="1"></app-property-duplicates>
      </div>
  </div>-->
        <!--Duplicate property End here-->
        <!--Financial Summary Starts here-->
        <!--Comps Start here-->
        <div class="col-md-12">
          <div *ngIf="activeTab == propertyTabs.FinancialSummary" class="border-div">
            <app-summary-details [tickerSymbol]="property.TickerSymbol" [tenant]="property.PropertyName" [showSummaryTab]="true"></app-summary-details>
          </div>
        </div>
        <!--Comps End here-->
        <!--Financial Summary Ends Here-->

      </div>
    </div>
    <div [hidden]="true">
      <ng-container *ngIf="!property.IsPortfolio">
        <h2 class="mainhead" *ngIf="similarProperties.length>0 && activeTab ==propertyTabs.Home && !this.authService.IsUserRole(this.authService.UserRole.Admin)&& !this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)">
          <span class="text">Similar Properties</span>
        </h2>
        <div class="row" *ngIf="activeTab ==propertyTabs.Home && !this.authService.IsUserRole(this.authService.UserRole.Admin)&& !this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)">
          <div class="col-md-4 col-lg-3 col-sm-6 col-xs-6 fullwidth600" *ngFor="let item of similarProperties">
            <be-property-card [property]="item" (propertyGuid)="onViewPropertyEvent($event)"></be-property-card>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<!--For Mobile view :: Download OM and Place Offer button-->
<!--<div class="visible-xs">
  <div class="ml-auto">

  </div>
  <div class="mobile_action_floated d-flex align-item-center justify-content-between">
    <button (click)="onTabClick(propertyTabs.Memorandom);" *ngIf="property.PropertyStatus != 'BOV' && property.PropertyStatus != 'Pre-Marketing'" class="btn-lg btn-border btn adduserbtn">Download OM</button>
    <button (click)="openPlaceOfferTab(propertyTabs.PlaceOffer)" class="btn btn-success  btn-lg" *ngIf="(property.PropertyStatus === 'Available' || property.PropertyStatus === 'Off-Market') && ((property.OfferPlaced == 0 || property.CancelledOffers !=0 || placeOfferVisibility) || authService.ExternalBroker()) && showPlaceOffer">Place Offer</button>
  </div>
</div>-->



<ng-template #template class="pull-left">
  <be-place-offer [modalRef]="modalRef" [placeOfferInputModel]="placeOfferInputModel" [showFileUpload]="showFileUpload" (offerPlaced)="getOfferPlaced($event)"></be-place-offer>
</ng-template>

<ng-template #inquiry class="pull-left">
  <be-place-offer [modalRef]="modalRef" [placeOfferInputModel]="placeOfferInputModel" [showFileUpload]="showFileUpload" (inquiryPlaced)="getInquiryPlaced($event)"></be-place-offer>
</ng-template>

<ng-template #login>
  <app-login-form [modalRef]="modalRef"></app-login-form>
</ng-template>

<ng-template #video>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Video</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="embed-responsive embed-responsive-16by9 be-video-container">
      <iframe class="embed-responsive-item" [src]="videoUrl"  frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
    </div>
  </div>
</ng-template>

<ng-template #deleteTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Offer Details</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to delete?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="deleteOffers();modalRef.hide();">Delete</button>
    </div>
  </div>
</ng-template>

<ng-template #verifyPropertyTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Notes</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefVerify.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label class="form-label">Notes</label>
      <textarea class="form-control property-description" placeholder="Enter Notes..." #notes="ngModel" maxlength="500" [(ngModel)]="updateTimestamp.Note" rows="3"></textarea>
      <p class="redtext" *ngIf="(isSubmit && Validation.IsinValid(updateTimestamp.Note))">Notes is required </p>
    </div>
    <div class="text-right">
      <button type="button" (click)="modalRefVerify.hide();updateTimestamp.Note=''" class="btn btn-default btn-lg">Cancel</button>
      <button type="button" (click)="VerifyProperty(property.Id)" [disabled]="disableBtn" class="btn btn-success btn-lg">Add Notes</button>
    </div>
  </div>

</ng-template>

<ng-template #loginpopup>
  <app-login-form [modalRef]="modalRef"></app-login-form>
</ng-template>
<ng-template #propertyShare>
  <app-share-property [property]="property" [modalRef]="modalRef"></app-share-property>
</ng-template>
<ng-template #DuplicateProperty>
  <app-duplicate-property-list [PropertyId]="selectedPropertyIdForDuplicates" [modalRef]="modalRefDuplicate" [Type]="1"></app-duplicate-property-list>
</ng-template>

<ng-template #addToExchange>
  <app-add-favorite-exchange [modalRef]="modalRefAddToExchange" [exchangeCodes]="exchangeCodes" (addToExchange)="addToExchangeSave($event)"></app-add-favorite-exchange>
</ng-template>
<button id="openModalButton" [hidden]="true" (click)="openLoginModal(loginpopup,'commonmodal',property.Guid)"></button>
<ng-template #preview>
  <div class="modal-header">

    <!--<h4 class="modal-title pull-left">{{docPreview.Name}}</h4>-->
    <button type="button" class="close pull-right" aria-label="Close" (click)="documentPreview.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ngx-extended-pdf-viewer [src]="docPreview.FilePath" [showBookmarkButton]="false" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>

  <!--<pdf-viewer [external-link-target]="'blank'" [show-all]="true" [show-borders]="true" [original-size]="true" [src]="docPreview.Url"
              [render-text]="true"
              style="display: block;"></pdf-viewer>-->
</ng-template>
<ng-template #addUsers>
  <app-add-user-to-dd [modalRef]="modalUserRef" [PropertyId]="propertyId" [OMRequireApproval]="OMApprovalRequired" [DDRequireApproval]="DDApprovalRequired" [Source]="source" [Type]="'OM'" [IsAgreementRequired]="IsAgreementRequired" [propertyGuid]="propertyGuid"></app-add-user-to-dd>
</ng-template>

<ng-template #ShareOM>
  <app-share-omdocuments [propertyIds]="sharedOmProperties" [modalRefShareListing]="modalRefOM" [SourcePage]="'Property-Details'" (removeProperties)="removeProperty($event)"></app-share-omdocuments>
</ng-template>

